import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from "../jsx.js";
import { Script } from "../Script.js";
import { Gist, parseGist } from "./Gist.js";
export function isMarkdownScript(node) {
    return node.tag === "script" && node.type === "11";
}
export function MarkdownScript({ tag, type, attrs }) {
    const loadTwitterOnReload = useCallback(() => {
        const { twttr } = window;
        if (twttr) {
            twttr.widgets.load();
        }
    }, [0]);
    if (!tag || !type || !attrs) {
        return null;
    }
    const scriptSrc = attrs.src;
    const gist = parseGist(scriptSrc, true);
    if (gist) {
        return _jsx(Gist, { ...gist });
    }
    // add twitter scripts
    if (scriptSrc?.indexOf("platform.twitter.com/widgets.js") > 0) {
        return _jsx(Script, { src: scriptSrc, onReload: loadTwitterOnReload });
    }
    return null;
}
